<script setup lang="ts">
// import type { Props } from './inputRange';
</script>

<template>
	<div class="top-inputRange">
		<!-- @slot Слот для поля ввода **От** -->
		<slot name="from"></slot>

		<span class="top-inputRange_dash">
			—
		</span>

		<!-- @slot Слот для поля ввода **До** -->
		<slot name="to"></slot>
	</div>
</template>

<style>
.top-inputRange {
	max-width: 320px;
	vertical-align: baseline;
	display: inline-flex;
	gap: 8px;
}

.top-inputRange_dash {
	height: var(--top-forms-base-height);
	color: var(--color-text-4);
	align-self: flex-end;
	display: inline-flex;
	align-items: center;
}

/* Вложенные компоненты */
.top-inputRange > .top-input {
	flex-grow: 1;
}
</style>
